import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RepromaterijalTableComponent } from './repromaterijal-table/repromaterijal-table.component';

const routes: Routes = [
  {
    path: '',
    component: RepromaterijalTableComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class RepromaterijalRoutingModule {}
